// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"4bb41c82","762":"135e8cc7","893":"f0937c8e","946":"6b1f7f22"}[chunkId] + ".chunk.js";
};